import React, { useState, useEffect } from 'react';
import { Mail, MessageCircle } from 'lucide-react';
import api from '../utils/api';
import { toast } from 'sonner';

const Contact = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await api.get('/config');
        setConfig(response.data);
      } catch (error) {
        console.error('Error fetching config:', error);
      }
    };
    fetchConfig();
  }, []);

  const handleWhatsApp = () => {
    if (config?.whatsapp_number) {
      const url = `https://wa.me/${config.whatsapp_number.replace(/[^0-9]/g, '')}`;
      window.open(url, '_blank');
    }
  };

  return (
    <div className="px-4 md:px-12 lg:px-24 py-24">
      <div className="max-w-2xl mx-auto">
        <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl tracking-tighter mb-12 text-center" data-testid="contact-title">
          Contacto
        </h1>
        
        <p className="text-center text-white/80 mb-16">
          Estamos aquí para ayudarte. Contáctanos a través de cualquiera de nuestros canales.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {config?.whatsapp_number && config?.whatsapp_enabled !== false && (
            <button
              onClick={handleWhatsApp}
              data-testid="contact-whatsapp"
              className="bg-[#0A0A0A] border border-white/10 hover:border-white/30 p-8 transition-all duration-300 text-center group"
            >
              <MessageCircle className="w-8 h-8 mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" />
              <h3 className="text-xs uppercase tracking-[0.2em] mb-2 font-semibold">WhatsApp</h3>
              <p className="text-sm text-white/60">{config.whatsapp_number}</p>
            </button>
          )}
          
          {config?.contact_email && (
            <a
              href={`mailto:${config.contact_email}`}
              data-testid="contact-email"
              className="bg-[#0A0A0A] border border-white/10 hover:border-white/30 p-8 transition-all duration-300 text-center group block"
            >
              <Mail className="w-8 h-8 mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" />
              <h3 className="text-xs uppercase tracking-[0.2em] mb-2 font-semibold">Email</h3>
              <p className="text-sm text-white/60">{config.contact_email}</p>
            </a>
          )}
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-white/60">
            Horario de atención: Lunes a Viernes, 9:00 - 18:00
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
